import React from "react";

const brands = ["Tesla Powerwall", "BYD", "Huawei Luna2000", "Sigenergy", "Sonnen", "Enphase", "SolarEdge", "Growatt", "Victron", "GoodWe"];

const LogoMarquee = () => {
  const items = [...brands, ...brands];
  return (
    <section className="py-12 bg-white border-y border-slate-200/70 overflow-hidden" data-testid="logo-marquee">
      <p className="text-center text-xs uppercase tracking-[0.3em] font-bold text-slate-500 mb-7">Wij installeren premium merken</p>
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10" />
        <div className="marquee-track">
          {items.map((b, i) => (
            <div key={i} className="px-10 flex items-center">
              <span className="font-heading font-black text-2xl md:text-3xl text-navy-900/70 tracking-tight whitespace-nowrap hover:text-brand transition-colors cursor-default">
                {b}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
